import { useEffect, useState } from 'react'

export interface IInputNumberProps {
  id: string
  ariaLabel: string
  placeholder?: string
  unit: string
  value: string
  label?: string
  onBlur: (value: string) => void
}

export default function InputNumber({
  id,
  ariaLabel,
  placeholder,
  unit,
  value,
  label,
  onBlur
}: IInputNumberProps) {

  const [draftValue, setDraftValue] = useState(value)

  useEffect(() => {
    setDraftValue(value)
  }, [value])

  return (
    <div className='flex-1 min-w-0'>
      {label && (
        <label
          htmlFor={id}
          className='block text-sm font-medium text-gray-700 mb-1'
        >
          {label}
        </label>
      )}
      <div className='relative'>
        <input
          id={id}
          style={{ paddingRight: '64px' }}
          type='text'
          inputMode='numeric'
          aria-label={ariaLabel}
          placeholder={placeholder}
          value={draftValue}
          onChange={(event) => {
            const nextValue = event.currentTarget.value
            if (/^\d*$/.test(nextValue)) setDraftValue(nextValue)
          }}
          onBlur={() => {
            if (draftValue !== value) {
              onBlur(draftValue)
            }
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
              event.preventDefault()
              onBlur(draftValue)
            }
          }}
          className='number-input appearance-none outline-hidden'
        />
        <span
          className='number-input-unit absolute inset-y-0 right-4 flex items-center pointer-events-none'
          aria-hidden='true'
        >
          {unit}
        </span>
      </div>
    </div>
  )
}